import { createAsyncThunk } from '@reduxjs/toolkit';
import { adminLookupsService } from './services';
import type {
  EscritorioLookup,
  LookupPaginatedResult,
  UsuarioLookup,
  LookupParams,
  UsuarioLookupSearchParams,
} from '../../types/lookups';

export const fetchEscritoriosLookup = createAsyncThunk<
  LookupPaginatedResult<EscritorioLookup>,
  void,
  { rejectValue: string }
>('adminLookups/fetchEscritorios', async (_, { rejectWithValue }) => {
  try {
    return await adminLookupsService.escritorios();
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar escritórios');
  }
});

export const searchEscritoriosLookup = createAsyncThunk<
  LookupPaginatedResult<EscritorioLookup>,
  LookupParams,
  { rejectValue: string }
>('adminLookups/searchEscritorios', async (params, { rejectWithValue }) => {
  try {
    return await adminLookupsService.escritorios(params);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar escritórios');
  }
});

export const fetchUsuariosLookup = createAsyncThunk<
  LookupPaginatedResult<UsuarioLookup>,
  void,
  { rejectValue: string }
>('adminLookups/fetchUsuarios', async (_, { rejectWithValue }) => {
  try {
    return await adminLookupsService.usuarios();
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar usuários');
  }
});

export const searchUsuariosLookup = createAsyncThunk<
  LookupPaginatedResult<UsuarioLookup>,
  UsuarioLookupSearchParams,
  { rejectValue: string }
>('adminLookups/searchUsuarios', async (params, { rejectWithValue }) => {
  try {
    return await adminLookupsService.usuarios(params);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar usuários');
  }
});
